import { useNavigate } from "react-router-dom";
import { TrendingUp, Receipt, Scale, Wallet } from "lucide-react";
import { useApi } from "../lib/api";
import { PageHeader, DataState, Kpi, SiteStatusBadge } from "../components/common";
import { eur2 as eur, pctText, signTone } from "../lib/format";
import { cn } from "../lib/utils";
import { SitesCostBars } from "../components/finance/CostCharts";

const COLS = [["contract_value", "Valore"], ["total_costs", "Costi"], ["received", "Incassato"], ["to_collect", "Da incassare"], ["supplier_due", "Da pagare"], ["margin", "Margine"]];

function OverviewRow({ r, onOpen }) {
  const s = r.summary;
  return (
    <tr onClick={() => onOpen(r.site.id)} className="border-b border-border/50 hover:bg-accent/40 cursor-pointer" data-testid={`finance-row-${r.site.id}`}>
      <td className="p-3"><div className="text-xs font-mono text-amber-400">{r.site.code}</div><div className="font-medium">{r.site.name}</div></td>
      <td className="p-3"><SiteStatusBadge status={r.site.status} /></td>
      {COLS.map(([k]) => <td key={k} className={cn("p-3 text-right num", k === "margin" && signTone(s.margin, "text-red-400", "text-emerald-300"))}>{eur(s[k])}</td>)}
      <td className="p-3 text-right num text-muted-foreground">{pctText(s.margin_pct)}</td>
    </tr>
  );
}

export default function Finance() {
  const nav = useNavigate();
  const { data, loading } = useApi("/finance/overview");
  const t = data?.totals;
  return (
    <div>
      <PageHeader eyebrow="Riservato amministratori" title="Economia" subtitle="Situazione economica e finanziaria di tutti i cantieri" />
      {t && (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mb-6">
          <Kpi label="Valore cantieri" value={eur(t.contract_value)} icon={TrendingUp} testid="finance-total-contract" />
          <Kpi label="Incassato / da incassare" value={eur(t.received)} hint={`Da incassare ${eur(t.to_collect)}`} icon={Wallet} accent="bg-emerald-500" testid="finance-total-received" />
          <Kpi label="Da pagare fornitori" value={eur(t.supplier_due)} icon={Receipt} accent="bg-orange-500" testid="finance-total-due" />
          <Kpi label="Margine stimato" value={eur(t.margin)} hint={`Saldo finanziario ${eur(t.cash_balance)}`} icon={Scale} accent={signTone(t.margin, "bg-red-500", "bg-sky-500") || "bg-sky-500"} testid="finance-total-margin" />
        </div>
      )}
      <DataState loading={loading && !data} empty={!data?.items?.length} emptyTitle="Nessun cantiere">
        <div className="surface overflow-x-auto">
          <table className="w-full text-sm min-w-[900px]" data-testid="finance-table">
            <thead><tr className="text-left text-xs uppercase tracking-wider text-muted-foreground border-b border-border">
              <th className="p-3">Cantiere</th><th className="p-3">Stato</th>{COLS.map(([k, l]) => <th key={k} className="p-3 text-right">{l}</th>)}<th className="p-3 text-right">%</th></tr></thead>
            <tbody>{(data?.items || []).map((r) => <OverviewRow key={r.site.id} r={r} onOpen={(id) => nav(`/cantieri/${id}?tab=economia`)} />)}</tbody>
          </table>
        </div>
        <div className="mt-6"><SitesCostBars rows={data?.items || []} /></div>
      </DataState>
    </div>
  );
}
